export * from './colaboradores-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/colaboradores-dialog/index.ts